import Vue from "vue";
import VueRouter from "vue-router";
//import { i18n } from "@/lang/lang.js";
//import { screenAuth } from "../assets/scripts/js/ScreenAuth";
import { appConfig } from "../assets/scripts/js/AppConfig";
//import { getParameter } from "../assets/scripts/js/GetParameter";

Vue.use(VueRouter);

const routes = [
  // ログイン
  {
    path: "/",
    alias: "/login",
    name: "Login",
    meta: {
      isPublic: true,
      screenId: appConfig.SCREEN_ID.P_COM_001,
    },
    component: () => import(/* webpackChunkName: "login" */ "../views/login.vue"),
  },
  // ０．ホーム
  {
    meta: {
      screenId: appConfig.MENU_ID.M_HOM,
    },
    path: "/" + appConfig.MENU_ID.M_HOM, //"/Home",
    name: appConfig.MENU_ID.M_HOM,
    component: () => import(/* webpackChunkName: "Home" */ "../views/common/Home.vue"),
  },
  // １．グループ設定
  {
    meta: {
      screenId: appConfig.SCREEN_ID.P_DDA_001,
    },
    path: "/" + appConfig.SCREEN_ID.P_DDA_001, //"/group_settings",
    name: appConfig.SCREEN_ID.P_DDA_001, //"GroupSettings",
    component: () =>
      import(/* webpackChunkName: "group_settings" */ "../views/groupsetting/GroupSettings.vue"),
  },
  // ２．グループ一覧
  {
    meta: {
      screenId: appConfig.SCREEN_ID.P_DDA_002,
    },
    path: "/" + appConfig.SCREEN_ID.P_DDA_002, //"/group_list",
    name: appConfig.SCREEN_ID.P_DDA_002, //"GroupList",
    component: () =>
      import(/* webpackChunkName: "group_list" */ "../views/grouplist/GroupList.vue"),
  },
  // ３．納期回答算出一覧
  {
    meta: {
      screenId: appConfig.SCREEN_ID.P_DDA_003,
    },
    path: "/" + appConfig.SCREEN_ID.P_DDA_003, //"/deli_date_ans_calc_list",
    name: appConfig.SCREEN_ID.P_DDA_003, //"DeliDateAnsCalcList",
    component: () =>
      import(
        /* webpackChunkName: "deli_date_ans_calc_list" */ "../views/delidateanscalc/DeliDateAnsCalcList.vue"
      ),
  },
  // 輸送依頼データ追加ダイアログ
  {
    meta: {
      isPublic: true,
      screenId: appConfig.SCREEN_ID.P_DDA_004,
    },
    path: `/${appConfig.SCREEN_ID.P_DDA_004}`,
    name: appConfig.SCREEN_ID.P_DDA_004,
    component: () => import("../views/delidateanscalc/AddDeliveryRequestDialog.vue"),
  },
  // ルート選択ダイアログ
  {
    meta: {
      isPublic: true,
      screenId: appConfig.SCREEN_ID.P_DDA_005,
    },
    path: `/${appConfig.SCREEN_ID.P_DDA_005}`,
    name: appConfig.SCREEN_ID.P_DDA_005,
    component: () => import("../views/delidateanscalc/RouteSettingDialog.vue"),
  },
  // 輸送能力一括登録
  {
    meta: {
      isPublic: true,
      screenId: appConfig.SCREEN_ID.P_DDA_009,
    },
    path: `/${appConfig.SCREEN_ID.P_DDA_009}`,
    name: appConfig.SCREEN_ID.P_DDA_009,
    component: () => import("../views/deliCapacityUpload/DeliCapacityUpload.vue"),
  },
  // 休業日登録
  {
    meta: {
      isPublic: true,
      screenId: appConfig.SCREEN_ID.P_DDA_010,
    },
    path: `/${appConfig.SCREEN_ID.P_DDA_010}`,
    name: appConfig.SCREEN_ID.P_DDA_010,
    component: () => import("../views/closeddayupdate/ClosedDayUpdate.vue"),
  },
  {
    path: "*",
    name: "not_found",
    meta: {
      isPublic: true,
      screenId: appConfig.SCREEN_ID.P_COM_001,
    },
    component: () => import("../views/login.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
